// extracted by mini-css-extract-plugin
export default {"style":"FormulaireAxe_style__keBjN","input":"FormulaireAxe_input__JMyi1","borderr":"FormulaireAxe_borderr__ybRz9","styleTitle":"FormulaireAxe_styleTitle__qHAbb"};